import { Container, Grid, Typography, Box, } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Eventback from '../../../Component/Eventback'
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';


export default function WorldAITechnology() {


    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);


    return (
        <>

            <Helmet>
                <meta charset="UTF-8" />
                <title>Decimal Point Analytics at World AI Expo 2025</title>
                <meta name="description" content="DPA showcased AI innovations in finance at World AI Expo 2025, highlighting automation, compliance, and ethical AI adoption in regulated industries." />
                <meta name="author" content="Decimal Point Analytics" />
                <link rel="canonical" href="https://www.decimalpointanalytics.com/world-ai-technology-expo-2025" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>



            <Box id='event-details' className='section sec_bg' component='section'>

                <Container maxWidth='lg' className='bdr'>

                    <Grid container spacing={1} alignItems="top" justifyContent='center'>
                        <Grid item lg={9} md={9} sm={12} xs={12}>
                            <Box>
                                <Typography variant='h2' className='subhead skblue al_center'>
                                    Events
                                </Typography>
                                <Typography variant='h1' className='mainhead blue al_center'>
                                    World AI Technology Expo 2025
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>


                    <Box className='whitebx'>
                        <Typography variant='h6' className='black jst'>
                            Decimal Point Analytics participated in the World AI Technology Expo 2025, a premier global event spotlighting the latest innovations in artificial intelligence, machine learning, and intelligent automation. Representing DPA at the event was Shailesh Dhuri, our Chief Executive Officer.
                        </Typography>

                        <Typography variant='h6' className='black jst'>
                            Shailesh Dhuri was invited as a panelist to share his insights on the evolving impact of AI across regulated industries, with a focus on financial services and data-driven decision-making.
                        </Typography>

                        <Typography variant='h6' className='black jst'>
                            Key themes addressed during the panel discussion included:
                        </Typography>

                        <Typography variant='h6' className='black jst'>
                            <ul>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        Applying AI for real-time risk assessment and compliance
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        Automating high-volume, complex financial operations
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        Integrating AI into legacy systems at scale
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        Data governance and ethical AI adoption
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        Future trends in enterprise-grade AI for financial institutions
                                    </Typography>
                                </li>
                            </ul>
                        </Typography>

                        <Typography variant='h6' className='black jst'>
                            The event served as a vital platform for engaging with global AI leaders, tech innovators, and decision-makers. DPA’s participation underscored its ongoing commitment to building AI-first solutions that enable precision, speed, and compliance for financial organizations worldwide.
                        </Typography>

                    </Box>

                    <Eventback />

                </Container >

            </Box >

        </>
    );
}
